import { BaseTableTransformer } from './BootstrapTableTransformer';
import { LiftProgressTableTransformer } from './LiftProgressTableTransformer';
import { ComplianceTableTransformer } from './ComplianceTableTransformer';
import { MarketplaceAttributionsTableTransformer } from './MarketplaceAttributionsTableTransformer';
import { ANALYTICS_TYPES } from '../../view/common/constants';

export const tableTransformerFactory = metaKey => {
    switch (metaKey) {
        case ANALYTICS_TYPES.LIFT_PROGRESS:
            return new LiftProgressTableTransformer();
        case ANALYTICS_TYPES.COMPLIANCE:
            return new ComplianceTableTransformer();
        case ANALYTICS_TYPES.MARKETPLACE_ATTRIBUTIONS:
            return new MarketplaceAttributionsTableTransformer();
        default:
            return new BaseTableTransformer();
    }
};



// WEBPACK FOOTER //
// ./src/lib/transformer/TableTransformerFactory.js